<template>
  <div v-if="form">
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <router-link
            class="title"
            :to="{name: 'UserList'}"
          >
            Edit your account
          </router-link>
        </div>
      </div>
    </section>

    <section class="container loading-data">
      <div class="columns">
        <div class="column">
          <div class="box">
            <form
              @submit.prevent="onSubmit"
              @reset="onReset"
            >
              <b-field
                label="Email"
              >
                <b-input
                  v-model="form.email"
                  type="email"
                  autofocus
                  required
                />
              </b-field>

              <b-field
                label="Password *"
              >
                <b-input
                  v-model="form.password"
                  type="password"
                  required
                />
              </b-field>

              <b-field
                label="Password Confirmation *"
              >
                <b-input
                  v-model="form.passwordConfirmation"
                  type="password"
                  required
                />
              </b-field>

              <nav class="level is-mobile">
                <div class="level-left" />
                <div class="level-right">
                  <b-button
                    size="is-primary"
                    native-type="submit"
                  >
                    Submit
                  </b-button>
                </div>
              </nav>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { DEFAULT_USER_VALUES } from '@/graphql/queries/users'
  import { formMixin } from '@/mixins/crud/form'
  import _ from 'lodash'

  export default {
    name: 'UserForm',
    mixins: [ formMixin('user') ],
    data: function() {
      return {
        form: JSON.parse(JSON.stringify(DEFAULT_USER_VALUES))
      }
    },
    computed: {
      'user'() {
        return this.byId(this.id)
      }
    },
    watch: {
      user() {
        if (this.id) {
          this.form = Object.assign({}, this.user)
        }
      }
    },
    methods: {
      onSubmit() {
        const sanitizedForm = _.pick(this.form, _.keys(DEFAULT_USER_VALUES))
        let vm = this
        this.save({id: parseInt(this.id), form: sanitizedForm}).then(function(response){
          if (response) {
            const responseId = response.data.users.id
            vm.$router.push({name: 'UserShow', params: {id: responseId}})
          }
        })
      },
      onReset() {
        this.form = JSON.parse(JSON.stringify(DEFAULT_USER_VALUES))
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>
